import { variant } from "styled-system";
import { createComponent, createHook } from "reakit-system";
import { cx, ecss } from "../reexports/emotion";
import type { TextHTMLProps, TextOptions } from "../Text/Text";
import { useText } from "../Text/Text";

const size = variant({
  prop: "size",
  variants: {
    default: {
      fontSize: "textBase",
      lineHeight: "textBaseLineHeight",
    },
    big: {
      fontSize: "textBig",
      lineHeight: "textBigLineHeight",
    },
    small: {
      fontSize: "textSmall",
      lineHeight: "textSmallLineHeight",
    },
  },
});

export type ParagraphOptions = TextOptions & {
  size?: "small" | "default" | "big";
};
export type ParagraphHTMLProps = TextHTMLProps;
export type ParagraphProps = ParagraphOptions & ParagraphHTMLProps;

export const useParagraph = createHook<ParagraphOptions, TextHTMLProps>({
  name: "Paragraph",
  keys: ["size"],
  compose: [useText],
  useProps(options, props) {
    return {
      ...props,
      className: cx(
        props.className,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument -- не наши типы
        ecss(size({ size: "default", ...options }), { label: "Paragraph" })
      ),
    };
  },
  useOptions(options) {
    return {
      ...options,
    };
  },
});

export const Paragraph = createComponent<"p", ParagraphOptions>({
  as: "p",
  useHook: useParagraph,
  memo: true,
});
